import { useEffect, useRef } from 'react';

import { Size as ScreenSize } from '@swf/core/enums';
import useLayoutEffect from '@swf/core/hooks/useIsomorphicLayoutEffect';
import useScreenSize from '@swf/core/hooks/useScreenSize';

const useOnMobileBreakpointChange = (callback: (isMobile: boolean) => void) => {
  const { greaterThan } = useScreenSize();
  const callbackRef = useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    callbackRef.current(!greaterThan(ScreenSize.Small));
  }, [greaterThan]);
};

export default useOnMobileBreakpointChange;
